import { SlReload } from "react-icons/sl";
import { HiOutlineArrowLongRight } from "react-icons/hi2";
import { TfiTime } from "react-icons/tfi";
import { CiUser } from "react-icons/ci";

const Icon = {
  reload: SlReload,
  rightArrow: HiOutlineArrowLongRight,
  Pending: TfiTime,
  User: CiUser,
};

export default Icon;
